<ng-content></ng-content>

@if (eduContentResultPending$ | async) {
  <div class="[ absolute top-0 left-0 bottom-0 right-0 ] [ center-items ]">
    <dcr-animated-kai [src]="'kai_state_machine.riv' | assetsPath: 'rive'" autoplay state="LOADING"></dcr-animated-kai>
  </div>
}
